import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { addDays, getUnixTime, subMinutes } from 'date-fns';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const preventDefault = <T extends Event>(event: T): T => {
  event.preventDefault();
  return event;
};

export { addDays, getUnixTime, subMinutes };
